// AC-819: lobby category types from GET /api/v1/games/public/categories.
export enum LobbyCategoryTypeEnum {
    STANDARD = 'STANDARD',
    POPULAR = 'POPULAR',
    PROVIDERS = 'PROVIDERS',
}
